module.exports = __webpack_public_path__ + "img/新区便民服务中心-品牌logo.ed6dba42.jpg";